import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/esm/extends";
var _Chevron;
const _excluded = ["interactive", "responsive"];
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { ChevronDown } from '@resultadosdigitais/tangram-react-icons';
import { breakpointLg } from '@resultadosdigitais/tangram-design-tokens';
import Dropdown from '../Dropdown';
import Avatar from '../Avatar';
import Text from '../Text';
import { NAVBAR_ACCOUNT_WIDTH } from './constants';
import useNavbarAccountContext from './useNavbarAccountContext';
const DISPLAY_NAME = 'NavbarAccount';
const UserName = styled(Text).attrs({
  forwardedAs: 'span',
  token: Text.tokens.TEXT_SM_BOLD,
  truncate: true
}).withConfig({
  displayName: "NavbarAccount__UserName",
  componentId: "sc-1rflrqi-0"
})([""]);
const AccountName = styled(Text).attrs({
  forwardedAs: 'span',
  token: Text.tokens.TEXT_XS_REGULAR,
  truncate: true
}).withConfig({
  displayName: "NavbarAccount__AccountName",
  componentId: "sc-1rflrqi-1"
})([""]);
const UserInfo = styled.div.withConfig({
  displayName: "NavbarAccount__UserInfo",
  componentId: "sc-1rflrqi-2"
})(["flex:1;width:0;"]);
const Chevron = styled(props => {
  return /*#__PURE__*/React.createElement(ChevronDown, _extends({}, props, {
    size: ChevronDown.sizes.xs,
    title: "Chevron down",
    "aria-hidden": "true"
  }));
}).attrs({
  fill: 'var(--neutral-icon-low-emphasis)'
}).withConfig({
  displayName: "NavbarAccount__Chevron",
  componentId: "sc-1rflrqi-3"
})([""]);
const Root = styled.div.withConfig({
  displayName: "NavbarAccount__Root",
  componentId: "sc-1rflrqi-4"
})(["display:flex;align-self:stretch;align-items:center;border:0;padding:var(--size-spacing-03) var(--size-spacing-04);background:transparent;text-align:left;&:disabled{color:var(--neutral-text-disabled);> ", "{fill:var(--neutral-icon-disabled);}}", " ", " ", ""], Chevron, _ref => {
  let {
    $responsive
  } = _ref;
  return $responsive && css(["", ",", ",", "{display:none;}@media (min-width:", "){gap:var(--size-spacing-02);width:", ";& + ", "{min-width:", ";}", ",", ",", "{display:block;}}"], UserName, AccountName, Chevron, breakpointLg, NAVBAR_ACCOUNT_WIDTH, Dropdown.Style, NAVBAR_ACCOUNT_WIDTH, UserName, AccountName, Chevron);
}, _ref2 => {
  let {
    $responsive
  } = _ref2;
  return !$responsive && css(["gap:var(--size-spacing-02);min-width:", ";", ",", ",", "{display:block;}"], NAVBAR_ACCOUNT_WIDTH, UserName, AccountName, Chevron);
}, _ref3 => {
  let {
    $interactive
  } = _ref3;
  return $interactive && css(["&:hover:not(:disabled),&:focus{cursor:pointer;> ", "{background-color:var(--primary-surface-low-emphasis);box-shadow:0 0 0 4px var(--neutral-border);@media (min-width:", "){box-shadow:none;}}", "{color:var(--primary-text);}}"], Avatar.Style, breakpointLg, UserName);
});

/**
 * @ignore - Do not document.
 */
const NavbarAccount = /*#__PURE__*/forwardRef((_ref4, ref) => {
  let {
      interactive,
      responsive
    } = _ref4,
    rest = _objectWithoutPropertiesLoose(_ref4, _excluded);
  const finalAs = interactive ? 'button' : 'div';
  const {
    avatarSrc,
    userName,
    accountName
  } = useNavbarAccountContext();
  return /*#__PURE__*/React.createElement(Root, _extends({}, rest, {
    $interactive: interactive,
    $responsive: responsive,
    as: finalAs,
    ref: ref
  }), /*#__PURE__*/React.createElement(Avatar, {
    src: avatarSrc,
    alt: userName
  }), /*#__PURE__*/React.createElement(UserInfo, null, /*#__PURE__*/React.createElement(UserName, null, userName), /*#__PURE__*/React.createElement(AccountName, null, accountName)), interactive && (_Chevron || (_Chevron = /*#__PURE__*/React.createElement(Chevron, null))));
});
NavbarAccount.displayName = DISPLAY_NAME;
NavbarAccount.Style = Root;
NavbarAccount.defaultProps = {
  interactive: false,
  responsive: false
};
export default NavbarAccount;